import React, {Component} from 'react';
import styled from 'styled-components'

import { DesktopBox } from '../Base';

import ChatGroupList from './ChatGroupList';
import ChatMessageList from './ChatMessageList';
import NewChatPopup from './NewChatPopup';

import { POPUP_MESSAGE_WINDOW_TYPE } from '../../constants/constants';

const ChatWrapper = styled.div`
    position: fixed;
    right: 40px;
    bottom: 0px;
    background: white;
    width: 300px;
    border-radius: 5px 5px 0px 0px;
    border-width: 1px;
    border-color: red;
`;


class ChatPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			isMinimized: true,
            popupType : POPUP_MESSAGE_WINDOW_TYPE.GROUP_LIST_WINDOW,
            chatId: null,
            chatTitle: '',
            studentMap: {},
			facultyMap: {}
		};
	}

    componentDidMount() {
        //this.fetchUsers();
    }

    fetchUsers  = async () => {
		this.setState({loading : true});
		let studentMap = {}, facultyMap = [];
		let studentRef = await this.props.firebase.students().get();
		studentRef.docs.forEach(doc => studentMap[doc.id] = doc.data());

		let facultyRef = await this.props.firebase.faculties().get();
		facultyRef.docs.forEach(doc => facultyMap[doc.id] = doc.data());

		this.setState({
			studentMap,
			facultyMap,
			loading: false
		});
    }
    
    /**
     * Handler to toggle Message Popup 
     */
    toggleBox = () => {
        const { isMinimized } = this.state;
        this.setState({
            isMinimized: !isMinimized
        });
    }

    /**
     * Switch to Message List Popup Window
     */
    switchMessageWindow = (chatId) => {
        this.setState({
            popupType: POPUP_MESSAGE_WINDOW_TYPE.MESSAGE_LIST_WINDOW,
            chatId,
        });
    }

    onBack = () => {
        this.setState({
            popupType: POPUP_MESSAGE_WINDOW_TYPE.GROUP_LIST_WINDOW,
        });
    }

    onEdit = () => {
        this.setState({
            popupType: POPUP_MESSAGE_WINDOW_TYPE.GROUP_CREATE_WINDOW,
        });
    }

    renderContent = () => {
        const { popupType, isMinimized, chatId, studentMap, facultyMap } = this.state;
        switch(popupType) {
            case POPUP_MESSAGE_WINDOW_TYPE.GROUP_LIST_WINDOW:
                return (
                    <ChatGroupList
                        {...this.props} 
                        isMinimized={isMinimized}
                        switchMessageWindow={this.switchMessageWindow}
                        edit={this.onEdit}
                        toggleBox={this.toggleBox}
                    /> 
                )
            case POPUP_MESSAGE_WINDOW_TYPE.MESSAGE_LIST_WINDOW:
                return (
                    <ChatMessageList
                        {...this.props} 
                        isMinimized={isMinimized}
                        chatId={chatId}
                        back={this.onBack}    
                        toggleBox={this.toggleBox}  
                        studentMap={studentMap}
                        facultyMap={facultyMap}          
                    /> 
                )
            case POPUP_MESSAGE_WINDOW_TYPE.GROUP_CREATE_WINDOW:
                return (
                    <NewChatPopup
                        {...this.props} 
                        isMinimized={isMinimized}
                        toggleBox={this.toggleBox}
                        back={this.onBack}    
                        switchMessageWindow={this.switchMessageWindow}
                    /> 
                )
            default: 
                return null;
        }
    }

    render() {
        const { profile, isFaculty } = this.props; 
        const { loading } = this.state;
        return (
            <DesktopBox>
                {
                    profile === null || profile === undefined || loading || window.location.pathname.includes("/app/chat") || !isFaculty ?  null :
                        <ChatWrapper>
                           {
                               this.renderContent()
                           }
                        </ChatWrapper>
                }
            </DesktopBox>
    	)
    }
  }

export default ChatPopup;